<div class="w-full h-full min-h-0 flex flex-col gap-4 raleway-font text-sm">
  <div class="flex items-center justify-between gap-4">
    <div>
      <h1 class="oswald-font text-3xl uppercase">
          Form Dashboard
      </h1>
    </div>
    <div class="relative">
      <button
        id="startFormDropdownButton"
        data-dropdown-toggle="startFormDropdown"
        type="button"
        class="flex items-center justify-center gap-2 px-4 py-2 rounded-md border border-nside-orange-100 bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 text-white"
      >
        Start Form
        <svg class="w-2.5 h-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4" />
        </svg>
      </button>
      <div id="startFormDropdown" class="z-10 hidden divide-y divide-gray-500 bg-orange-50 rounded-md w-40">
        <ul class="py-2" aria-labelledby="startFormDropdownButton">
          @for (formOption of formOptions; track formOption.formName) {
            <li>
              <a
                [routerLink]="['/building', buildingId(), formOption.formName]"
                class="block px-4 py-2 hover:bg-white hover:text-nside-orange-400"
              >
                {{ formOption.label }}
              </a>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>

  <div class="w-full flex-1 min-h-0 p-1">
    <div class="w-full h-full rounded-md bg-white shadow-custom-2 p-6 flex flex-col gap-4 overflow-hidden">
    @if (loading()) {
      <spinner pageName="form-dashboard"></spinner>
    } @else {
      <div class="relative shrink-0">
        <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search-icon lucide-search"><path d="m21 21-4.34-4.34"/><circle cx="11" cy="11" r="8"/></svg>
        </div>
        <input
          type="search"
          class="block w-full p-2 ps-10 text-sm text-gray-500 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500" 
          [ngModel]="searchQuery()"
          (ngModelChange)="updateSearch($event)"
          placeholder="Search form records..."
        />
      </div>

      <div class="flex-1 min-h-0 overflow-y-auto">
        @if (filteredRecords().length > 0) {
          <table class="w-full text-left">
          <thead class="oswald-font uppercase text-gray-700 bg-main-background">
            <tr>
              <th scope="col" class="px-4 py-3 w-14">
                <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                  No.
                </div>
              </th>
              <th scope="col" class="px-4 py-3 min-w-48">
                <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap" (click)="sortBy('form_name')">
                  Form
                </div>
              </th>
              <th scope="col" class="px-4 py-3 min-w-40">
                <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap" (click)="sortBy('date_submitted')">
                  Submitted At
                </div>
              </th>
              <th scope="col" class="px-4 py-3 min-w-40">
                <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap" (click)="sortBy('user_name')">
                  Submitted By
                </div>
              </th>
              <th scope="col" class="px-4 py-3 min-w-32">
                <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                  Actions
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (record of paginatedRecords(); track record.id; let rowIndex = $index) {
              <tr class="bg-white border-b">
                <th scope="row" class="px-4 py-4">
                  {{ rowIndex + 1 + (page() - 1) * itemsPerPage }}
                </th>
                <td class="px-4 py-4">
                  <div class="flex flex-col">
                    <span class="font-medium text-slate-900">{{ record.form_name }}</span>
                  </div>
                </td>
                <td class="px-4 py-4">{{ record.date_submitted | date: 'MM/dd/yyyy - HH:mm' }}</td>
                <td class="px-4 py-4">{{ record.user_name }}</td>
                <td class="px-4 py-4">
                  <button
                    type="button"
                    class="inline-flex items-center rounded border border-nside-gray-300 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50"
                    (click)="downloadRecord(record)"
                  >
                    Download
                  </button>
                </td>
              </tr>
            }
          </tbody>
          </table>
        } @else {
          <div class="w-full p-4 text-nside-gray-100 italic">No form records found.</div>
        }
      </div>
      <div class="shrink-0 flex justify-between items-center gap-4">
        <p>{{ filteredRecords().length }} in total</p>
        @if (filteredRecords().length > itemsPerPage) {
          <div class="mt-2 flex items-center gap-2 text-sm flex-wrap justify-end">
            <button
              type="button"
              class="rounded border border-slate-300 px-3 py-1 text-slate-700 disabled:opacity-40"
              [disabled]="page() === 1"
              (click)="previousPage()"
            >
              Prev
            </button>
            @for (pageNumber of pageNumbers(); track pageNumber) {
              <button
                type="button"
                class="rounded border px-3 py-1"
                [class.border-nside-orange-400]="pageNumber === page()"
                [class.bg-nside-orange-400]="pageNumber === page()"
                [class.text-white]="pageNumber === page()"
                [class.border-slate-300]="pageNumber !== page()"
                [class.text-slate-700]="pageNumber !== page()"
                (click)="goToPage(pageNumber)"
              >
                {{ pageNumber }}
              </button>
            }
            <button
              type="button"
              class="rounded border border-slate-300 px-3 py-1 text-slate-700 disabled:opacity-40"
              [disabled]="page() === totalPages()"
              (click)="nextPage()"
            >
              Next
            </button>
          </div>
        }
      </div>
    }
    </div>
  </div>
</div>

<popup-message
  [type]="messageModal()"
  [message]="popupMessage()"
  (close)="resetMessageModal()"
></popup-message>
